/**
 * Component for managing parallax behavior.  Has option of supporting
 * svg clipPath for image masking.
 */


/* global jQuery */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

const dc = require('../utilities/device-check');


function initModule(options) {
    let $img = $(options.image),
        $svg = $(options.svg),
        $bg = $(options.bg),
        $clipPath = $(options.clipPath),
        $clipShape = $(options.clipShape),
        $container = $(options.container),
        imgHeight = null,   // Track this for scroll calculations
        imgRatio = options.imageHeight / options.imageWidth,
        svgRatio = options.clipPathHeight / options.clipPathWidth,
        svgScaleTransform = (1 / options.imageWidth) + ' ' + (1 / options.imageHeight),
        moduleTop = $container.offset().top,
        moduleHeight = $container.outerHeight(),
        ieScaleRatio = 1,
        intensity = options.intensity,
        isBottomAnchored = options.bottomAnchor;

    function setImageSize() {

        let imgWidth,
            svgWidth = imgWidth =  $(window).innerWidth(),
            svgHeight = svgWidth * svgRatio;
        
        // Track this outside of local function for scroll calc purposes
        imgHeight = imgWidth * imgRatio;

        // Reset the module top, in case elements have resized
        moduleTop = $container.offset().top;
        
        // Calculate min height to get image to fit
        // across entire scroll area w parallax factored in
        moduleHeight = $container.outerHeight();
        let minHeight = moduleHeight * (1 + intensity);
        let scaleFactor = 1;    // Scale factor is amount we need to scale the
                                // image up by in order to cover the available
                                // background space, while still allowing for 
                                // scroll area required (start at 1)

        // Ensure we have enough height at the (already) calculated image size
        if (minHeight > imgHeight) {
            scaleFactor = minHeight / imgHeight;
            svgWidth *= scaleFactor;
            svgHeight *= scaleFactor;
            imgWidth *= scaleFactor;
            imgHeight *= scaleFactor;
        }
  
        // Set image and svgsize
        $svg.attr('width', svgWidth).attr('height', svgHeight);
        $img.attr('width', imgWidth).attr('height', imgHeight);

        // Prep the IE scale ratio value, used to correctly position the clip path in IE/Edge
        // ieScaleRatio = options.imageWidth / (imgWidth * scaleFactor);
        ieScaleRatio = options.imageWidth / imgWidth;

        positionImage();
    }

    function positionImage() {
        // Check to see if the module is in view.  If not, abort.
        let scrollTop = $(window).scrollTop(),
            winHeight = $(window).outerHeight();
        if (scrollTop < (moduleTop - winHeight)) {
            return;
        }
        // Calculate percentage distance of its visible travel up the screen the module has gone
        let totalAvailableDistance = winHeight + moduleHeight,
            ratioTraveled = ((scrollTop + winHeight) - moduleTop) / totalAvailableDistance;

        ratioTraveled = (ratioTraveled > 1) ? 1 : ratioTraveled;

        // Calculate the current y position for the image
        // NOTE: Tracking of the image to the module area can 'stray' a bit at the bottom edge.
        // This is only an issue when the bg is bottom-anchored, in which case we reduce the
        // 'intensity' of the offset in order to keep the image within the confines of 
        // the parent module.
        let offsetIntensity = isBottomAnchored ? .7 : 1;
        let imgOffset = (imgHeight - moduleHeight) * (1 - ratioTraveled) * -1 * offsetIntensity;

        $img.attr('y', imgOffset);
        
        // Scale the clipping path to fit the image
        $clipPath.attr('transform', 'scale(' + svgScaleTransform + ')');
        if (dc.isIE()) {
            // We also have to apply an 'inverse' y translation on the clipping path for 
            // IE and Edge, in order to keep the svg path positioned correctly. Note that
            // this needs to be applied to the shape itself, not the outer clip path.
            $clipShape.attr('transform', 'translate(0, ' + (imgOffset * ieScaleRatio * -1) + ')');
        }
    }

    $(window).resize(() => {
        setImageSize();
    });
    $(window).scroll(() => {
        positionImage();
    });

    setImageSize();

}


exports.setupParallax = function(options) {
    // First, check to see if this is a touch device.  If so, use a static
    // background (older iOS devices struggle with correct image tracking).
    if (dc.isMobileOrTablet()) {
        let $container = $(options.container);
        $container.addClass('js-static-bg');
        return;
    }
    initModule(options);
};